import React from "react";
import PropTypes from "prop-types";
import { Label, FormGroup, FormFeedback } from "reactstrap";
import { Field } from "formik";

import withErrors from "shared/formik/withErrors";

const FormRowField = ({ name, label, children, tooltipErrors, ...props }) => (
  <Field name={name}>
    {withErrors(({ field, fieldErrors }) => (
      <FormGroup {...props}>
        {label && (
          <Label className="sb-field-label" for={name}>
            {label}
          </Label>
        )}
        {children({ field })}
        <FormFeedback tooltip={tooltipErrors}>{fieldErrors}</FormFeedback>
      </FormGroup>
    ))}
  </Field>
);

FormRowField.propTypes = {
  name: PropTypes.string.isRequired,
  children: PropTypes.func.isRequired,
  label: PropTypes.string,
  tooltipErrors: PropTypes.bool
};

FormRowField.defaultProps = {
  label: "",
  tooltipErrors: false
};

export default FormRowField;
